const STREET_SUFFIXES = new Set([
  "st", "street", "ave", "avenue", "av", "rd", "road", "dr", "drive", "ln", "lane", "blvd", "boulevard",
  "ct", "court", "way", "pl", "place", "ter", "terrace", "cir", "circle", "hwy", "highway", "pkwy",
  "parkway", "trl", "trail", "sq", "square", "aly", "alley", "pike", "loop", "run", "path", "xing", "crossing",
]);
const UNIT_WORDS = new Set(["apt", "apartment", "unit", "ste", "suite", "fl", "floor", "rm", "room", "bldg", "building", "lot"]);
const DIRECTIONALS = { north: "n", south: "s", east: "e", west: "w", northeast: "ne", northwest: "nw", southeast: "se", southwest: "sw" };
const DIRECTIONAL_ABBREVIATIONS = new Set(Object.values(DIRECTIONALS));

const normalizeAddress = (value) =>
  String(value || "").toLowerCase().replace(/@/g, "").replace(/[^a-z0-9]+/g, " ").trim();

// Mirrors canvasing-app-backend-api/app/services/addressFilter.js so the offline
// filter and the server return the same streets.
export const parseAddress = (value) => {
  let tokens = normalizeAddress(value).split(" ").filter(Boolean);
  let number = null;
  if (tokens.length > 0 && /^\d+[a-z]?$/.test(tokens[0])) number = tokens.shift();

  const unitIndex = tokens.findIndex((token, index) => index > 0 && UNIT_WORDS.has(token));
  if (unitIndex > 0) tokens = tokens.slice(0, unitIndex);

  tokens = tokens.map((token) => DIRECTIONALS[token] || token);

  let suffixIndex = -1;
  tokens.forEach((token, index) => {
    if (STREET_SUFFIXES.has(token)) suffixIndex = index;
  });
  if (
    suffixIndex > 0 &&
    tokens.slice(suffixIndex + 1).every((token) => DIRECTIONAL_ABBREVIATIONS.has(token))
  ) {
    tokens.splice(suffixIndex, 1);
  }

  return { number, street: tokens.join(" ") };
};

// value is the filter option: "1" for odd, "2" for even. The house number decides;
// the stored house_number_type is only used when no number can be read.
export const matchesHouseParity = (properties, value) => {
  const props = properties || {};
  const match = String(props.house_number || props.aristotle_house_num || "").match(/\d+/);
  if (!match) return props.house_number_type === value;
  const isOdd = parseInt(match[0], 10) % 2 === 1;
  return value === "1" ? isOdd : !isOdd;
};

export const streetNameMatches = (phrase, address) => {
  const wanted = parseAddress(phrase);
  if (!wanted.street) return ` ${normalizeAddress(address)} `.includes(` ${normalizeAddress(phrase)} `);
  const actual = parseAddress(address);
  if (wanted.street !== actual.street) return false;
  return !wanted.number || wanted.number === actual.number;
};
